import { Variants } from "framer-motion";

export const anim = (variants: Variants) => {
  return {
    variants,
    initial: "initial",
    animate: "animate",
    exit: "exit",
    whileTap: "tap",
  };
};

export const modalUp = {
  initial: { y: "100%" },
  animate: {
    y: 0,
    transition: {
      duration: 0.4,
      delay: 0.1,
      ease: [0.165, 0.84, 0.44, 1],
    },
  },
  exit: {
    y: "100%",
    transition: { duration: 0.4, ease: [0.165, 0.84, 0.44, 1] },
  },
};

export const modalIn = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: {
      duration: 0.4,
      delay: 0.1,
      ease: [0.165, 0.84, 0.44, 1],
    },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.4, ease: [0.165, 0.84, 0.44, 1] },
  },
};
